module.exports = "/logo-vertical-ba3f6c36813d60203127165081ca8c20.svg";